<template>
  <transition name="modal-fade">
    <div
      v-if="show"
      :class="modalClassName"
      transition="modal"
      @mousedown="handleMouseDown"
    >
<!--      d99d add prevent for click-->
      <div
        ref="container"
        :class="modalContainerClassName"
        role="dialog"
        aria-modal="true"
        tabindex="-1"
        @mouse.stop
        @mousedown="event => event.stopPropagation()"
      >
        <woot-button
          v-if="showCloseButton"
          color-scheme="secondary"
          icon="dismiss"
          variant="clear"
          class="absolute ltr:right-2 rtl:left-2 top-2 z-[70]"
          @click.prevent="close"
        />
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    closeOnEscape: {
      type: Boolean,
      default: true,
    },
    closeOnBackdropClick: {
      type: Boolean,
      default: true,
    },
    show: Boolean,
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    modalType: {
      type: String,
      default: 'centered',
    },
    size: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mousedDownOnBackdrop: false,
      previouslyFocused: null,
    };
  },
  computed: {
    modalContainerClassName() {
      let className =
        'modal-container bg-white dark:bg-slate-800 skip-context-menu';
      if (this.fullWidth) {
        return `${className} modal-container--full-width`;
      }

      return `${className} ${this.size}`;
    },
    modalClassName() {
      const modalClassNameMap = {
        centered: '',
        'right-aligned': 'right-aligned',
      };

      return `modal-mask skip-context-menu ${
        modalClassNameMap[this.modalType] || ''
      }`;
    },
  },
  watch: {
    // QM §5.10 — move focus into the dialog on open and hand it back on close, so
    // keyboard users are not left stranded behind the overlay.
    show(isVisible) {
      if (isVisible) {
        this.previouslyFocused = document.activeElement;
        this.$nextTick(this.focusFirstElement);
        return;
      }
      if (this.previouslyFocused && this.previouslyFocused.focus) {
        this.previouslyFocused.focus();
      }
      this.previouslyFocused = null;
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyEvents);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeyEvents);

    document.body.addEventListener('mouseup', this.onMouseUp);
  },
  beforeDestroy() {
    document.body.removeEventListener('mouseup', this.onMouseUp);
  },
  methods: {
    handleKeyEvents(e) { // d99d
      if (!this.show) {
        return;
      }
      if (e.code === 'Escape' && this.closeOnEscape) {
        this.onClose();
        return;
      }
      if (e.code === 'Tab') {
        this.trapFocus(e);
      }
    },
    // QM §5.10 — visible, enabled controls inside the dialog, in DOM order.
    focusableElements() {
      const container = this.$refs.container;
      if (!container) {
        return [];
      }
      const selector =
        'a[href], button:not([disabled]), textarea:not([disabled]), ' +
        'input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return Array.from(container.querySelectorAll(selector)).filter(
        el => el.offsetParent !== null
      );
    },
    focusFirstElement() {
      const [first] = this.focusableElements();
      if (first) {
        first.focus();
      } else if (this.$refs.container) {
        this.$refs.container.focus();
      }
    },
    // QM §5.10 — Tab cycles within the dialog instead of escaping to the page behind it.
    trapFocus(e) {
      const elements = this.focusableElements();
      const container = this.$refs.container;
      if (!elements.length || !container) {
        return;
      }
      const first = elements[0];
      const last = elements[elements.length - 1];
      const active = document.activeElement;

      if (e.shiftKey && (active === first || !container.contains(active))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    },
    handleMouseDown() {
      this.mousedDownOnBackdrop = true;
    },
    close() {
      this.onClose();
    },
    onMouseUp() {
      if (this.mousedDownOnBackdrop) {
        this.mousedDownOnBackdrop = false;
        this.onClose();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.modal-container--full-width {
  align-items: center;
  border-radius: 0;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.modal-mask.right-aligned {
  justify-content: flex-end;

  .modal-container {
    border-radius: 0;
    height: 100%;
    width: 30rem;
  }
}
.modal-big {
  width: 60%;
}
</style>
